import React from 'react'
import styles from './_error.css'
import { FormattedMessage } from 'react-intl'

export default function ErrorNotification () {
  return (
    <div className={styles.errorNotification}>
      <div className={styles.errorNotificationText}>
        <FormattedMessage
          id='notifications.error'
          defaultMessage='This page encountered an error.  Please refresh and try again.' />
      </div>
    </div>
  )
}
